<template>
  <div :class="$style.text_wrap">
    <p :class="[$style.assistant, type ? $style[type] : '']">
      <span><i class="fa-solid fa-user-doctor-message"></i> Welcome to talkの健康相談</span>
      <spacer :y="1"/>
      <ul>
        <li>相談員はすべて現役の医師・心理士。経験豊富なこころの専門家が一人ひとりの相談に応じます。 </li>
        <li>診療や診断など医療行為は行いませんが、どんな些細なことでも気軽にご相談ください。 </li>
        <li>いのちに関わるご相談は、学校や企業、警察と連携する場合があります。あらかじめご了承ください。 </li>
        <li>{{ fourthNotificationMessage }}</li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: 'counseling-notification',
  props: {
    type: {
      type: String,
      default: null,
      validator: (value) => ['text', 'online', 'virtual'].includes(value),
    },
  },
  data() {
    return {
    };
  },
  computed: {
    fourthNotificationMessage() {
      if (this.type === 'text') {
        return '相談内容の秘匿性を確保し、また意図しない情報流出を防ぐため、ご利用者のみなさまの複製・転載等はご遠慮いただいております。';
      }
      if (this.type === 'online' || this.type === 'virtual') {
        return '相談内容の秘匿性を確保し、また意図しない情報流出を防ぐため、ご利用者のみなさまの録音・録画等はご遠慮いただいております。';
      }
      return '相談内容の秘匿性を確保し、また意図しない情報流出を防ぐため、ご利用者のみなさまの録音・録画・複製・転載等はご遠慮いただいております。';
    },
  },
};
</script>

<style lang="scss" module>
.assistant {
  width: 80%;
  margin: 0 auto;
  background-color: var(--gray-sub);
  font-size: 1.2em;
  line-height: 1.8;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 5px 5px 10px rgba(black, .15);

  &.text {
    background-color: var(--blue-sub-light);
  }
  &.online {
    background-color: var(--orange-sub-light);
  }
  &.virtual {
    background-color: var(--green-sub-light);
  }
  span {
    font-size: 18px;
    display: block;
    font-weight: bold;
    i {
      margin-right: .5em;
    }
  }

  ul {
    padding-left: 1em;
  }

  li {
    margin-bottom: .5em;
    list-style: disc;
    list-style-position: outside;
  }
  li:last-child {
    margin-bottom: 0;
  }

  @include sm-view {
    font-size: 14px;
    width: 100%;
    span {
      font-size: 16px;
    }
  }
}
</style>
